module.exports = __webpack_public_path__ + "static/Logo-24cdfa92218f2bfc128e3d2b33b12d9a.png";